import React, { useCallback, useEffect, useState } from 'react';
import { api, moeda } from '../api';
import { Campo, Carregando, Chip, Modal, useToast } from '../components/Base';

export default function Planos() {
  const [lista, setLista] = useState(null);
  const [editando, setEditando] = useState(null); // objeto plano ou {} para novo
  const avisar = useToast();
  const carregar = useCallback(() => api('/planos').then(setLista).catch(e => avisar(e.message, 'erro')), [avisar]);
  useEffect(() => { carregar(); }, [carregar]);

  if (!lista) return <Carregando />;
  return (
    <>
      <div className="linha" style={{ marginBottom: 14 }}>
        <span className="mudo">O valor do plano é usado quando a empresa não tem valor negociado.</span>
        <span className="espaco" />
        <button className="btn" onClick={() => setEditando({})}>Novo plano</button>
      </div>
      <div className="cartao tabela-wrap mob-cards" style={{ padding: 0 }}>
        <table>
          <thead><tr><th>Código</th><th>Nome</th><th className="num">Valor/mês</th><th>Descrição</th><th className="num">Empresas</th><th>Situação</th><th></th></tr></thead>
          <tbody>
            {lista.map(p => (
              <tr key={p.codigo}>
                <td data-label="Código"><code>{p.codigo}</code></td>
                <td data-label="Nome">{p.nome}</td>
                <td className="num" data-label="Valor">{moeda(p.valor)}</td>
                <td data-label="Descrição">{p.descricao || '—'}</td>
                <td className="num" data-label="Empresas">{p.qtd_tenants}</td>
                <td data-label="Situação"><Chip status={p.ativo ? 'ativo' : 'cancelado'}>{p.ativo ? 'Ativo' : 'Inativo'}</Chip></td>
                <td style={{ textAlign: 'right' }}><button className="btn secundario pequeno" onClick={() => setEditando(p)}>Editar</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {editando && <FormPlano plano={editando} onFechar={() => setEditando(null)} onSalvo={() => { setEditando(null); avisar('Plano salvo'); carregar(); }} />}
    </>
  );
}

function FormPlano({ plano, onFechar, onSalvo }) {
  const novo = !plano.codigo;
  const [f, setF] = useState({ codigo: plano.codigo || '', nome: plano.nome || '', valor: plano.valor ?? '', descricao: plano.descricao || '', ativo: plano.ativo === undefined ? true : !!plano.ativo });
  const [salvando, setSalvando] = useState(false);
  const avisar = useToast();
  async function salvar() {
    setSalvando(true);
    try {
      if (novo) await api('/planos', { method: 'POST', body: f });
      else await api('/planos/' + plano.codigo, { method: 'PUT', body: f });
      onSalvo();
    } catch (e) { avisar(e.message, 'erro'); } finally { setSalvando(false); }
  }
  return (
    <Modal titulo={novo ? 'Novo plano' : 'Editar plano'} largura={460} onFechar={onFechar} rodape={<><button className="btn secundario" onClick={onFechar}>Voltar</button><button className="btn" onClick={salvar} disabled={salvando}>Salvar</button></>}>
      {novo && <Campo label="Código (letras minúsculas, sem espaço)"><input value={f.codigo} onChange={e => setF({ ...f, codigo: e.target.value.toLowerCase().replace(/[^a-z0-9_-]/g, '') })} placeholder="ex.: premium" /></Campo>}
      <Campo label="Nome"><input value={f.nome} onChange={e => setF({ ...f, nome: e.target.value })} /></Campo>
      <Campo label="Valor mensal (R$)"><input type="number" step="0.01" min="0" inputMode="decimal" value={f.valor} onChange={e => setF({ ...f, valor: e.target.value })} /></Campo>
      <Campo label="Descrição"><input value={f.descricao} onChange={e => setF({ ...f, descricao: e.target.value })} /></Campo>
      {!novo && <label className="linha" style={{ gap: 8 }}><input type="checkbox" checked={f.ativo} onChange={e => setF({ ...f, ativo: e.target.checked })} /> Plano ativo (aparece para escolher)</label>}
    </Modal>
  );
}
